<script setup lang="ts">
import {useModalStore} from "../../../store/modal";
import {useChatStore} from "../../../store/chat";
import DefaultModalBase from "../DefaultModalBase.vue";
import {computed, ref} from "vue";

const store = useChatStore()
const modalStore = useModalStore()
const is_sent = ref(false)
const loading = ref(false)

const heading = computed(() => is_sent.value ? 'The template has been sent to the client.' : 'Are you sure you want to send this template to the client?')
const sendTemplate = async () => {
    loading.value = true
    await store.sendTemplateMessage(modalStore.props?.template_name)
    is_sent.value = true
    loading.value = false
}
</script>

<template>
    <DefaultModalBase :heading icon="arrow-reply"
                      :loading>
        <div class="send-template-actions">
            <brand-button @click="sendTemplate()" v-if="!is_sent">Yes, send template</brand-button>
            <brand-button variant="secondary" @click="modalStore.close(is_sent)">
                {{ !is_sent ? "Nevermind" : "Done" }}
            </brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.send-template-actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>
